var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteBottom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 12.5824C23.9305 12.66 23.8503 12.7279 23.7875 12.8152C20.9305 16.7863 18.0735 20.7574 15.2166 24.7285C15.1573 24.8109 15.0945 24.8885 15.0107 25C15.0107 16.6554 15.0107 8.3495 15.0107 0C18.0073 0 21.0038 0 24.0003 0C24.0003 4.19414 24.0003 8.38829 24.0003 12.5824Z",
    fill: "#D9DBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0146484C3.00349 0.0146484 5.98605 0.0146484 8.99302 0.0146484C8.99302 0.135866 8.99302 0.242538 8.99302 0.34921C8.99302 4.30577 8.99302 8.25747 8.98605 12.214C8.98605 12.374 8.93372 12.5825 8.85349 12.694C5.95814 16.733 3.05581 20.7672 0.153488 24.8013C0.111628 24.8595 0.0662791 24.9128 0 25.0001C0 16.6506 0 8.34475 0 0.0146484Z",
    fill: "#D9DBE9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteBottom);
export default __webpack_public_path__ + "static/media/quote-bottom.1eb98d8501fb40b1aea99c0f63fa2363.svg";
export { ForwardRef as ReactComponent };